import { BaseService } from '../../infra/base.service'
import type { ReportEntity } from './report'
import type { ReportsRepository } from './reports.repository'

export class ReportsService extends BaseService<ReportEntity> {
    constructor(private rep: ReportsRepository) {
        super(rep)
    }
}
